import React, { useEffect, useState, useMemo } from "react";
import "../styles/ProjectsPage.css";
import projects from "../components/Projects";
import ProjectCard from "../components/ProjectCard";
import ProjectModal from "../components/ProjectModal";

const ProjectsPage = () => {

    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedTechs, setSelectedTechs] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    useEffect(() => {
        if (selectedProject) {
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";
        } else {
            document.documentElement.style.overflow = "";
            document.body.style.overflow = "";
        }

        return () => {
            document.documentElement.style.overflow = "";
            document.body.style.overflow = "";
        };
    }, [selectedProject]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isDropdownOpen && !event.target.closest('.custom-dropdown-container')) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [isDropdownOpen]);

    const { allTechnologies, techCounts } = useMemo(() => {
        const counts = {};
        projects.forEach(project => {
            if (project.technologies) {
                project.technologies.forEach(tech => {
                    counts[tech] = (counts[tech] || 0) + 1;
                });
            }
        });
        const techs = Object.keys(counts).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
        return { allTechnologies: techs, techCounts: counts };
    }, []);

    const filteredProjects = useMemo(() => {
        if (selectedTechs.length === 0) {
            return projects;
        }
        return projects.filter(project =>
            selectedTechs.every(tech => project.technologies && project.technologies.includes(tech))
        );
    }, [selectedTechs]);

    const toggleTech = (tech) => {
        setSelectedTechs(prev => {
            if (prev.includes(tech)) {
                return prev.filter(t => t !== tech);
            } else {
                return [...prev, tech];
            }
        });
    };

    const handleTechClick = (tech) => {
        setSelectedTechs([tech]);
        const container = document.getElementById("projects-container");
        if (container) {
            container.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div className="container" id="projects-container"
            style={{ paddingTop: "200px", marginBottom: "50px", minHeight: "100vh", textAlign: "center", color: "white" }}>
            <div className="about-title" style={{
                fontWeight: "bold",
                textShadow: "rgba(0, 0, 0, 0.35) 0px 5px 40px",
            }}>
                Projects
            </div>

            <div className="filter-wrapper d-flex flex-column align-items-center mb-4 mt-3">
                <div className="custom-dropdown-container">
                    <button
                        className={`dropdown-trigger-btn ${selectedTechs.length > 0 ? 'active' : ''}`}
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                        <i className="bi bi-funnel-fill me-2"></i>
                        {selectedTechs.length === 0 ? "Filter by Stack" : `Filtered Stacks (${selectedTechs.length})`}
                        <i className={`bi bi-chevron-${isDropdownOpen ? 'up' : 'down'} ms-2`}></i>
                    </button>

                    {isDropdownOpen && (
                        <div className="dropdown-options-panel">
                            <div className="dropdown-options-list">
                                {allTechnologies.map(tech => {
                                    const isSelected = selectedTechs.includes(tech);
                                    return (
                                        <button
                                            key={tech}
                                            className={`dropdown-option-item ${isSelected ? 'active' : ''}`}
                                            onClick={() => toggleTech(tech)}
                                        >
                                            <span className="option-text-group">
                                                {isSelected && <i className="bi bi-check-lg me-2 text-primary-glow"></i>}
                                                {tech}
                                            </span>
                                            <span className="option-count-badge">{techCounts[tech]}</span>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>

                {selectedTechs.length > 0 && (
                    <div className="active-filters-container d-flex flex-wrap justify-content-center align-items-center mt-3">
                        {selectedTechs.map(tech => (
                            <span key={tech} className="active-filter-pill">
                                {tech}
                                <button className="remove-pill-btn" onClick={() => toggleTech(tech)}>
                                    <i className="bi bi-x"></i>
                                </button>
                            </span>
                        ))}
                        <button className="clear-all-pills-btn" onClick={() => setSelectedTechs([])}>
                            Clear All
                        </button>
                    </div>
                )}
            </div>

            <div className="d-flex justify-content-center">
                {filteredProjects.length > 0 ? (
                    <div className="projects-grid d-flex flex-wrap justify-content-center align-items-center">
                        {filteredProjects.map((project) => (
                            <ProjectCard
                                key={project.name}
                                project={project}
                                onClick={() => setSelectedProject(project)}
                                onTechClick={handleTechClick}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="no-projects-message">
                        <p>No projects match all the selected technologies.</p>
                        <button className="clear-all-pills-btn px-4 py-2" onClick={() => setSelectedTechs([])}>
                            Reset Filters
                        </button>
                    </div>
                )}
                <ProjectModal
                    project={selectedProject}
                    onClose={() => setSelectedProject(null)}
                    onTechClick={handleTechClick}
                />
            </div>
        </div>

    );
};

export default ProjectsPage;
